import React from "react";
import { Grid, Typography } from "@material-ui/core/";
import { makeStyles } from "@material-ui/core/styles";
import trumpetLeft from "../images/trumpet.svg";
import trumpetRight from "../images/trumpet-right.svg";

import trumpetGrayLeft from "../images/trump-left-gray.svg";
import trumpetGrayRight from "../images/trump-right-gray.svg";

const TrumpetTitle = ({ title, color }) => {
  const trumpetRightImage = color === "#363c45" ? trumpetRight:trumpetGrayRight
  const trumpetLeftImage = color === "#363c45" ? trumpetLeft:trumpetGrayLeft
  const useStyles = makeStyles((theme) => ({
    "trumpet-left": {
      marginRight: 10,
      fill:color,
    },
    "trumpet-right": {
      marginLeft: 10,
      fill:color,
    },
    "font-size": {
      fontSize: 16,
      color,
      fontWeight: 500,
      fontFamily: "Oswald",
    },
  }));
  const classes = useStyles();
  return (
    <div>
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="center"
        className={classes["font-size"]}
      >
        <img
          src={trumpetLeftImage}
          className={classes["trumpet-left"]}
          height={20}
          alt="trumpet"
        ></img>

        <Typography
          variant="h6"
          align="center"
          className={classes["conteiner-margin"]}
        >
          {title}
        </Typography>
        <img
          src={trumpetRightImage}
          className={classes["trumpet-right"]}
          height={20}
          alt="trumpet"
        ></img>
      </Grid>
    </div>
  );
};
export default TrumpetTitle;
